// @ts-strict-ignore
import { defaultEmarsysTracking } from './default-emarsys-tracking'
import { typedWindow } from './helpers/types'
import { CartFragmentFragment } from '@generated'

type VisitCategory = {
  category: string
  customerId?: number
  cart: null | CartFragmentFragment
}

export function emarsysCategoryVisit({ category, customerId, cart }: VisitCategory) {
  if (typedWindow.ScarabQueue) {
    typedWindow.ScarabQueue.push(['category', category])

    defaultEmarsysTracking({ customerId, cart })
  }
}
